export const updateReportStatus = /* GraphQL */ `
  mutation updateReportStatus($reportId: String!) {
    updateReportRes: MPCUpdateContentReport(reportId: $reportId) {
      status
    }
  }
`;
